var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurnbyTurn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ba320696-bf6e-4d80-afa4-5790022eb216",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .bbfe04e6-401d-4f5d-a73a-a6497b8ba5ab {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "bbfe04e6-401d-4f5d-a73a-a6497b8ba5ab",
    points: "54.51 29.833 54.51 32.157 61.838 31.761 59.492 35.624 62.241 39.21 54.51 39.627 54.51 41.952 66.758 41.29 62.299 35.472 66.105 29.207 54.51 29.833"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "bbfe04e6-401d-4f5d-a73a-a6497b8ba5ab",
    points: "45.49 40.115 39.653 40.43 36.905 36.843 39.251 32.981 45.49 32.644 45.49 30.321 37.904 30.731 34.097 36.995 38.557 42.814 45.49 42.439 45.49 40.115"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbfe04e6-401d-4f5d-a73a-a6497b8ba5ab",
    d: "M52.189,12.7V9.412a2.189,2.189,0,1,0-4.378,0V12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bbfe04e6-401d-4f5d-a73a-a6497b8ba5ab",
    d: "M47.811,28.021V50.588a2.189,2.189,0,1,0,4.378,0V28.021Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "bbfe04e6-401d-4f5d-a73a-a6497b8ba5ab",
    points: "65.519 25.7 29.78 25.7 34.481 20.358 29.78 15.016 65.519 15.016 70.22 20.358 65.519 25.7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnbyTurn);
export default __webpack_public_path__ + "static/media/TurnbyTurn.35bea225d6e05966d5bb1ef2da6cd2ee.svg";
export { ForwardRef as ReactComponent };